import { Component, OnInit, ViewChild } from '@angular/core';
import { ContactMessage } from '../../models/contact-message.model';
import { NgForm } from '@angular/forms';
import { PortalService } from '../../services/portal.service';
import { SiteService } from '../../../../core/services/site.service';

@Component({
  templateUrl: './contact.page.html',
  styleUrls: ['./contact.page.scss']
})
export class ContactPage implements OnInit {

  @ViewChild('messageForm') messageForm: NgForm;
  @ViewChild('captchaRef') captchaRef;
  contactMessage: ContactMessage = new ContactMessage();
  siteKey: string = '';
  constructor(private portalService: PortalService,
    private siteService: SiteService) { }

  ngOnInit() {
    this.siteService.getGoogleConfiguration().subscribe(({siteKey}) => {
      this.siteKey = siteKey;
    });
  }

  resolveCaptcha(captchaResponse: string) {
    this.contactMessage.recaptchaResponse = captchaResponse;
  }

  sendMessage() {
    if(!this.messageForm.valid || !this.contactMessage.recaptchaResponse)
      return;
    this.portalService.postMessage(this.contactMessage).subscribe();
  }

}
